<template>
  <div class="profitableList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
        @click="gotoDetail(item)"
      >
        <div class="list-item">
          {{ $t.profitableList.mainWbNumber }}：{{ item.PWB_Number }}
        </div>
        <div class="list-item">
          {{ $t.profitableList.sideWbNumber }}：{{ item.WB_Number }}
        </div>
        <div class="list-item">
          {{ $t.profitableList.destinationPort }}：{{ item.POD }}
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            v-show="dataQueryCriteria == item.value"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.statistics }}</div>
        <van-radio-group
          v-model="dataQueryCriteria"
          direction="horizontal"
          @change="statisticsChange"
        >
          <van-radio :name="0">{{ $t.profitableList.dataOtion0 }}</van-radio>
          <van-radio :name="1">{{ $t.profitableList.dataOtion1 }}</van-radio>
          <van-radio :name="2">{{ $t.profitableList.dataOtion2 }}</van-radio>
          <van-radio :name="3">{{ $t.profitableList.dataOtion3 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.profitableList.userType }}</div>
        <van-radio-group v-model="userType" direction="horizontal">
          <van-radio :name="1">{{ $t.profitableList.usType1 }}</van-radio>
          <van-radio :name="2">{{ $t.profitableList.usType2 }}</van-radio>
          <van-radio :name="3">{{ $t.profitableList.usType3 }}</van-radio>
          <van-radio :name="4">{{ $t.profitableList.usType4 }}</van-radio>
        </van-radio-group>

        <van-field
          v-model="selectedRefer.text"
          :label="$t.profitableList.refer"
          @click="pickerShow('showReferPicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
        />

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showReferPicker" round position="bottom">
      <van-picker
        :label="$t.profitableList.refer"
        show-toolbar
        :columns="roleList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="referConfirm"
        @cancel="showReferPicker = false"
      />
    </van-popup>

    <div class="tool-bar">
      <div class="tool-bar-wrapper" v-if="showStatistics">
        <van-button block @click="showStatistics = false">{{
          $t.meta.hideStatistics
        }}</van-button>

        <div class="tool-bar-total" v-if="rateList && rateList.length > 0">
          <div class="tool-bar-total-left">{{ $t.profitableList.rate }}</div>
          <div class="tool-bar-total-item" v-for="(item, index) in rateList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.Rate }}</div>
          </div>
        </div>

        <div class="tool-bar-total">
          <div class="tool-bar-total-left">
            {{ $t.profitableList.received }}
          </div>
          <div class="tool-bar-total-item" style="width: 75%">
            <div class="item1">{{ settlementCurrency }}</div>
            <div class="item2">{{ receivedTotalAmount }}</div>
          </div>
        </div>

        <div class="tool-bar-total">
          <div class="tool-bar-total-left">{{ $t.profitableList.paid }}</div>
          <div class="tool-bar-total-item" style="width: 75%">
            <div class="item1">{{ settlementCurrency }}</div>
            <div class="item2">{{ paidTotalAmount }}</div>
          </div>
        </div>

        <div class="tool-bar-total">
          <div class="tool-bar-total-left">{{ $t.profitableList.profits }}</div>
          <div class="tool-bar-total-item" style="width: 75%">
            <div class="item1">{{ settlementCurrency }}</div>
            <div class="item2">{{ totalAmount }}</div>
          </div>
        </div>
      </div>
      <div class="tool-bar-wrapper" v-else>
        <van-button type="info" block @click="showStatistics = true">{{
          $t.meta.showStatistics
        }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "profitableList",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //统计
      showStatistics: false,
      settlementCurrency: "",
      rateList: [],
      totalAmount: null,
      receivedTotalAmount: null,
      paidTotalAmount: null,
      //推荐人
      roleList: [],
      showReferPicker: false,
      selectedRefer: { text: "", value: null },
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.profitableList.invoiceNo,
          value: 0,
        },
        {
          text: this.$t.profitableList.wbNumber,
          value: 1,
        },
        {
          text: this.$t.profitableList.warehouseWorkNumber,
          value: 2,
        },
        {
          text: this.$t.profitableList.jobNumber,
          value: 3,
        },
      ],
      dataQueryCriteria: 1,
      userType: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  created() {
    this.defaultDate();
    this.getUserListByCondition();
  },
  methods: {
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      let da =
        date.getDate() < 10 ? "0" + date.getDate().toString() : date.getDate().toString();
      let end = year + "-" + month + "-" + da;
      let beg = year + "-" + month + "-01";
      this.beginTime = beg;
      this.endTime = end;
    },
    gotoDetail(item) {
      var data = item;
      data.SettlementCurrency = this.settlementCurrency;
      data.RateList = this.rateList;
      localStorage.setItem("profitableListDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "profitableListDetail",
        name: "profitableListDetail",
        query: [],
      });
    },
    statisticsChange(e) {
      this.searchType = e;
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList();
    },
    isFilter() {
      if (this.userType || this.selectedRefer.value) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.dataQueryCriteria = 1;
      this.userType = null;
      this.selectedRefer = { text: "", value: null };
      this.defaultDate();
      this.initList();
      this.getList();
    },
    filterSubmit() {
      this.initList();
      this.getList();
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    getList() {
      var param = {
        Referrer: this.selectedRefer.value,
        UserType: this.userType,
        DataQueryCriteria: this.dataQueryCriteria,
        InvoiceNo: this.searchType == 0 ? this.searchText : "",
        WB_Number: this.searchType == 1 ? this.searchText : "",
        WarehouseWorkNumber: this.searchType == 2 ? this.searchText : "",
        WorkOrderNumber: this.searchType == 3 ? this.searchText : "",
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      this.$api.financialManagement
        .getProfitStatisticsList(param)
        .then((res) => {
          this.tableData = res.data.ProfitableList;
          this.rateList = res.data.RateList;
          this.totalAmount = res.data.TotalAmount;
          this.receivedTotalAmount = res.data.ReceivedTotalAmount;
          this.paidTotalAmount = res.data.PaidTotalAmount;
          this.settlementCurrency = res.data.SettlementCurrency;
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    referConfirm(e) {
      this.selectedRefer.text = e.text;
      this.selectedRefer.value = e.value;
      this.showReferPicker = false;
    },
    getUserListByCondition() {
      return new Promise((resolve) => {
        this.$api.systemManagement
          .getUserListByCondition({
            CompanyId: this.CompanyId,
            IsUse: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.UserName,
                value: item.UserId,
              };
              result.push(data);
            });
            this.roleList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.profitableList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        padding-bottom: 10px;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar-total {
    font-size: 12px;
    color: #333333;
    background: #fff;
    .tool-bar-total-left {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .checkbox {
        display: inline-flex;
        span {
          margin-left: 10px;
        }
      }
    }
    .tool-bar-total-item {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
    .tool-bar-wrapper {
      border-bottom: 1px solid #f6f6f6;
    }
  }
}
</style>
